// Background task manager for reminders
// Note: Overdue status is now fully managed by the backend cron job
// The backend marks reminders as OVERDUE after 10 minutes of being NOTIFIED
// Frontend no longer does client-side overdue detection

class BackgroundTaskManager {
  private intervals = new Map<string, NodeJS.Timeout>();

  // Deprecated: Overdue checking is now handled by the backend
  // Kept as no-op for backwards compatibility with existing code that calls these methods
  startOverdueChecker(_intervalMinutes = 15) {
    // No-op - backend handles overdue detection with 10-minute grace period after notification
  }

  stopOverdueChecker() {
    const interval = this.intervals.get('overdueChecker');
    if (interval) {
      clearInterval(interval);
      this.intervals.delete('overdueChecker');
    }
  }

  startAllTasks() {
    // No client-side tasks needed - backend handles overdue detection
  }

  stopAllTasks() {
    this.intervals.forEach(interval => clearInterval(interval));
    this.intervals.clear();
  }
}

export const backgroundTasks = new BackgroundTaskManager();